import React, { useState } from 'react';
import { Row, Col, Modal, ModalBody, ModalFooter } from 'reactstrap';
import styles from './ViewFileModal.module.css';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { pdfjs } from 'react-pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export const ViewFileModal = ({ isOpen, toggle, centered, selectedDoc }) => {
    const [isPdf, setIsPdf] = useState(
        selectedDoc?.documentName?.substring(selectedDoc?.documentName?.lastIndexOf('.') + 1) === 'pdf' ? true : false
    );
    const [documentData, setDocumentData] = useState(selectedDoc?.documentData || null);

    const base64ToUint8array = (base64) => {
        const binaryString = atob(base64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            modalClassName='viewDocModal'
            contentClassName='viewDocModalContent'
            centered={centered}
            size='lg'
        >
            <div className={styles.viewDocModalHeader}>
                <h4
                    className={'mb-0'}
                    id='exampleModalLongTitle'
                >
                    {selectedDoc?.documentName}
                </h4>
            </div>
            <ModalBody className={styles.viewDocModalBody}>
                {documentData && (
                    <Row className='justify-content-center'>
                        <Col
                            md='8'
                            className={documentData && isPdf ? styles.pdfViewer : styles.docImage}
                        >
                            {documentData && isPdf ? (
                                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.5.207/build/pdf.worker.min.js`}>
                                    <div>
                                        <Viewer
                                            fileUrl={base64ToUint8array(documentData)}
                                            plugins={
                                                [
                                                    // defaultLayoutPluginInstance,
                                                ]
                                            }
                                        />
                                    </div>
                                </Worker>
                            ) : (
                                <img
                                    src={`data:image/png;base64,${documentData}`}
                                    alt='Image'
                                />
                            )}
                        </Col>
                    </Row>
                )}
            </ModalBody>
            <ModalFooter>
                <button
                    className='btn-primary'
                    onClick={toggle}
                >
                    Close
                </button>
            </ModalFooter>
        </Modal>
    );
};
